export default {
	events: {
		'ddc.link.generic': [
			{
				insertion: 'unshift',
				logic: {
					'eventData.attributes.data-name': 'show-print-coupon'
				},
				payload: {
					type: 'CustomTagEvent',
					eventName: 'couponClick',
					eventAction: 'pageElementInteraction',
					attributes: {
						linkText: '[[eventData.text]]',
						couponName: '[[eventData.attributes.data-couponid]]'
					}
				},
				trigger: 'telephonicURL'
			},
			{
				insertion: 'unshift',
				logic: {
					'eventData.attributes.data-mopar-coupon-print': true
				},
				payload: {
					type: 'CustomTagEvent',
					eventName: 'couponClick',
					eventAction: 'pageElementInteraction',
					attributes: {
						linkText: '[[eventData.text]]',
						couponName: '[[eventData.attributes.data-coupon-id]]'
					}
				},
				trigger: 'telephonicURL'
			},
			{
				insertion: 'unshift',
				logic: {
					'eventData.attributes.data-mopar-coupon-email': true
				},
				payload: {
					type: 'CustomTagEvent',
					eventName: 'couponClick',
					eventAction: 'pageElementInteraction',
					attributes: {
						linkText: '[[eventData.text]]',
						couponName: '[[eventData.attributes.data-coupon-id]]'
					}
				},
				trigger: 'telephonicURL'
			}
		]
	}
};
